export default () => {
  const storeModule = require('store/store');
  const store = storeModule.getStore();
  return store ? store.getState() : {};
};
